(() => {
  const format = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Oslo',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
  function update() {
    const parts = Object.fromEntries(format.formatToParts(new Date()).map(p=>[p.type,p.value]));
    const seconds = 86400 - (Number(parts.hour)*3600 + Number(parts.minute)*60 + Number(parts.second));
    document.querySelectorAll('[data-daily-countdown]').forEach(timer=>{
      timer.querySelector('[data-hours]').textContent=String(Math.floor(seconds/3600)).padStart(2,'0');
      timer.querySelector('[data-minutes]').textContent=String(Math.floor(seconds%3600/60)).padStart(2,'0');
      timer.querySelector('[data-seconds]').textContent=String(seconds%60).padStart(2,'0');
    });
    const bar=document.querySelector('[data-matilde-fixed-announcement]');
    if(bar) document.documentElement.style.setProperty('--matilde-announcement-height',bar.offsetHeight+'px');
    const header = document.querySelector('#SiteHeader');
    if(header) document.documentElement.style.setProperty('--matilde-mobile-header-height',header.offsetHeight+'px');
    const wrapper=document.querySelector('#HeaderWrapper');
    if(wrapper)document.documentElement.style.setProperty('--emilia-header-height',wrapper.offsetHeight+'px');
  }
  if(window.matildeDailyTimer)clearInterval(window.matildeDailyTimer);
  update();window.matildeDailyTimer=setInterval(update,1000);
  if(window.ResizeObserver){const header=document.querySelector('#HeaderWrapper');if(header)new ResizeObserver(update).observe(header);}
  window.addEventListener('load',update,{once:true});
  window.addEventListener('resize',update,{passive:true});
  document.addEventListener('visibilitychange',update);document.addEventListener('shopify:section:load',update);
})();
